import { render } from "./index.vue?vue&type=template&id=ebd08756&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./assets/index.response.less?vue&type=style&index=0&id=ebd08756&scoped=true&lang=less&external"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd08756"]])

export default __exports__